import CeisaPpjkIndex from "@/components/exim/ceisa/ppjk/CeisaPpjkIndex.vue";
import CeisaPpjkDetail from "@/components/exim/ceisa/ppjk/CeisaPpjkDetail.vue";
import CeisaPpjkEdit from "@/components/exim/ceisa/ppjk/CeisaPpjkEdit.vue";
import CeisaPpjkCreate from "@/components/exim/ceisa/ppjk/CeisaPpjkCreate.vue";

let CeisaPpjkRoute= [
    {
        path: '',
        meta: {
          title: "Ceisa Client Login",
        },
        name: "CeisaPpjkIndex",
        component: CeisaPpjkIndex
    },

    {
      path: 'detail/:id',
      meta: {
        title: "Ceisa System Code Detail",
      },
      name: "CeisaPpjkDetail",
      component: CeisaPpjkDetail
    },

    {
      path: 'edit/:id',
      meta: {
        title: "Ceisa System Code Update",
      },
      name: "CeisaPpjkEdit",
      component: CeisaPpjkEdit
    },

    {
      path: 'create',
      meta: {
        title: "Ceisa System Code Create",
      },
      name: "CeisaPpjkCreate",
      component: CeisaPpjkCreate
    }
    
]

export default CeisaPpjkRoute
  